import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { HttpApiComponent } from "./component";

export const HttpApiV2Container = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  httpApiStackStatus: StackStatus | null;
}) => {
  const { deploymentId, httpApiStackStatus } = props;

  return (
    <HttpApiComponent
      loading={false}
      deploymentId={deploymentId}
      httpApiStackParamsJson={httpApiStackStatus?.parametersJSON || null}
      httpApiStackStatus={httpApiStackStatus?.status || null}
    />
  );
};
